import React, { useState, useEffect, useRef } from 'react';
import { getAssetUrl } from '../../utils/helpers';
import { useNotification } from '../../context/CustomDialogContext';
import { useLocation, Link } from 'react-router-dom';
import PublicHeader from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import PublicCouponBanner from '../../components/PublicCouponBanner';
import { useLeadModal } from '../../context/LeadModalContext';
import { useCountry } from '../../context/CountryContext';
import { apiGet } from '../../services/api';
import heroCourseImage200 from '../../assets/images/courses/200hr-yttc.webp';
import heroCourseImage300 from '../../assets/images/courses/300hr-yttc.webp';
import heroCourseImage500 from '../../assets/images/courses/500hr-yttc.webp';
import heroCourseImageKids from '../../assets/images/courses/95-hour-kids-yoga-ttc.webp';
import heroCourseImageDiet from '../../assets/images/courses/diet-and-nutrition.webp';
import heroCourseImageFace from '../../assets/images/courses/face-yoga-ttc.webp';




// Reusable SVG Icon Components for Wellness Theme
const Icons = {
  lotus: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
      <path d="M12 6a6 6 0 016 6v2a6 6 0 01-12 0v-2a6 6 0 016-6z" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  verify: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
  ),
  certificate: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 12l2 2 4-4M7.833 21.003L12 16.5l4.167 4.503M12 3a9 9 0 100 18 9 9 0 000-18z" />
    </svg>
  ),
  dashboard: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  ),
  calendar: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  clock: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  support: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 18v-6a9 9 0 0118 0v6" />
      <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" />
    </svg>
  ),
  guidance: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
    </svg>
  ),
  teacher: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 00-3-3.87" />
      <path d="M16 3.13a4 4 0 010 7.75" />
    </svg>
  ),
  rishikesh: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2L2 22h20L12 2z" />
      <path d="M12 6l-8 13h16l-8-13z" />
      <path d="M8 14c2.5 0 2.5 2 5 2s2.5-2 5-2" />
    </svg>
  ),
  star: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  plus: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  check: (
    <svg className="pf-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" style={{ width: '16px', height: '16px' }}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
};

// Reusable Premium Highlight Card Component
const HighlightCard = ({ icon, text, type = "teal", style = {} }) => {
  const highlightIcons = {
    info: (
      <svg className="pf-highlight-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </svg>
    ),
    check: (
      <svg className="pf-highlight-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
      </svg>
    ),
    certificate: (
      <svg className="pf-highlight-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </svg>
    ),
    trust: (
      <svg className="pf-highlight-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 6h2v2h-2V8zm0 4h2v6h-2v-6z" />
      </svg>
    ),
    lotus: (
      <svg className="pf-highlight-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 4a8 8 0 110 16 8 8 0 010-16z" />
      </svg>
    ),
    rishikesh: (
      <svg className="pf-highlight-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12 2L2 22h20L12 2zM12 6l-8 13h16l-8-13zM8 14c2.5 0 2.5 2 5 2s2.5-2 5-2" />
      </svg>
    )
  };

  return (
    <div className={`pf-highlight-card ${type}`} style={style}>
      {highlightIcons[icon] || highlightIcons.info}
      <p className="pf-highlight-text" style={style.color ? { color: style.color } : {}}>{text}</p>
    </div>
  );
};

// FAQ Accordion Card Subcomponent
const FaqCard = ({ question, answer, isActive, onToggle }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState('0px');

  useEffect(() => {
    setHeight(isActive ? `${contentRef.current.scrollHeight}px` : '0px');
  }, [isActive]);

  return (
    <div className={`pf-faq-card ${isActive ? 'active' : ''}`}>
      <div className="pf-faq-header" onClick={onToggle}>
        <h3 className="pf-faq-question">{question}</h3>
        <span className="pf-faq-icon">
          {Icons.plus}
        </span>
      </div>
      <div
        ref={contentRef}
        className="pf-faq-content"
        style={{ maxHeight: height }}
      >
        <div className="pf-faq-content-inner">
          {answer}
        </div>
      </div>
    </div>
  );
};

const Home = () => {
  const location = useLocation();
  const { openModal } = useLeadModal();
  const { selectedCountry, formatPrice } = useCountry();

  const [coursesData, setCoursesData] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(true);
  const [activeCoupons, setActiveCoupons] = useState([]);
  const [upcomingBatchesMap, setUpcomingBatchesMap] = useState({});
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let isMounted = true;
    async function loadCourseAndPricingData() {
      try {
        const [cRes, couponRes] = await Promise.allSettled([
          apiGet('/public-courses.php'),
          apiGet('/public-banner-coupons.php')
        ]);

        if (isMounted && cRes.status === 'fulfilled' && Array.isArray(cRes.value)) {
          setCoursesData(cRes.value);
        } else if (isMounted) {
          setCoursesData([]);
        }

        let couponList = [];
        if (couponRes.status === 'fulfilled' && couponRes.value) {
          const val = couponRes.value;
          if (Array.isArray(val)) couponList = val;
          else if (Array.isArray(val.data)) couponList = val.data;
          else if (Array.isArray(val.list)) couponList = val.list;
        }
        if (couponList.length === 0) {
          try {
            const fallbackCoupons = await apiGet('/public-coupons.php');
            if (Array.isArray(fallbackCoupons)) couponList = fallbackCoupons;
            else if (fallbackCoupons?.data) couponList = fallbackCoupons.data;
          } catch (e) {}
        }
        if (isMounted) setActiveCoupons(couponList);

        const courseTitles = [
          "200 Hour Yoga Teacher Training",
          "300 Hour Yoga Teacher Training",
          "500 Hour Yoga Teacher Training",
          "Kids Yoga Teacher Training",
          "95-Hour Kids Yoga Teacher Training",
          "Diet and Nutrition Course",
          "Face Yoga Teacher Training Course"
        ];
        const batchPromises = courseTitles.map(t =>
          apiGet(`/get-upcoming-batches.php?course_title=${encodeURIComponent(t)}`).catch(() => [])
        );
        const batchResults = await Promise.allSettled(batchPromises);
        if (isMounted) {
          const bMap = {};
          courseTitles.forEach((t, idx) => {
            const res = batchResults[idx];
            if (res.status === 'fulfilled' && Array.isArray(res.value) && res.value.length > 0) {
              bMap[t] = res.value;
            }
          });
          setUpcomingBatchesMap(bMap);
        }
      } catch (err) {
        console.warn('Home course & pricing data load error:', err);
      } finally {
        if (isMounted) {
          setCoursesLoading(false);
        }
      }
    }
    loadCourseAndPricingData();
    return () => { isMounted = false; };
  }, []);

  const parseDateSafe = (dateStr) => {
    if (!dateStr) return null;
    let cleanStr = String(dateStr).trim();
    if (!cleanStr) return null;

    let d = new Date(cleanStr);
    if (!isNaN(d.getTime())) return d;

    cleanStr = cleanStr.replace('T', ' ').replace(/-/g, '/');
    d = new Date(cleanStr);
    if (!isNaN(d.getTime())) return d;

    d = new Date(cleanStr.replace(/ /g, 'T'));
    if (!isNaN(d.getTime())) return d;

    return null;
  };

  const getValidCouponForCourse = (dbCourse) => {
    if (!dbCourse || !Array.isArray(activeCoupons) || activeCoupons.length === 0) return null;

    const now = currentTime.getTime();

    // Find all matching coupons for this course (specific course_id first, then global course_id 0)
    const matchingCoupons = activeCoupons.filter((c) => {
      if (!c) return false;
      const cId = Number(c.course_id);
      return cId === Number(dbCourse.id) || cId === 0;
    });

    matchingCoupons.sort((a, b) => {
      const aSpecific = Number(a.course_id) === Number(dbCourse.id) ? 1 : 0;
      const bSpecific = Number(b.course_id) === Number(dbCourse.id) ? 1 : 0;
      return bSpecific - aSpecific;
    });

    for (const match of matchingCoupons) {
      if (match.status && match.status !== 'active') continue;

      const isShowOnPages = match.show_on_pages === undefined || match.show_on_pages === null || match.show_on_pages === 1 || match.show_on_pages === '1' || match.show_on_pages === true;
      if (!isShowOnPages) continue;

      if (match.banner_expiry) {
        const expDate = parseDateSafe(match.banner_expiry);
        if (expDate && expDate.getTime() - now <= 0) continue;
      }
      if (match.banner_start) {
        const startDate = parseDateSafe(match.banner_start);
        if (startDate && now < startDate.getTime()) continue;
      }
      if (match.expiry_date) {
        const expDate = parseDateSafe(match.expiry_date);
        if (expDate && expDate.getTime() - now <= 0) continue;
      }

      return match;
    }

    return null;
  };

  const formatCountdown = (expiryDateStr) => {
    const expDate = parseDateSafe(expiryDateStr);
    if (!expDate) return '';

    const difference = expDate.getTime() - currentTime.getTime();
    if (difference <= 0) return 'Offer ended.';

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    const parts = [];
    if (days > 0) {
      parts.push(`${days}d`);
    }
    parts.push(`${String(hours).padStart(2, '0')}h`);
    parts.push(`${String(minutes).padStart(2, '0')}m`);
    parts.push(`${String(seconds).padStart(2, '0')}s`);

    return parts.join(' ');
  };

  const formatExpiryDisplay = (dateStr) => {
    const d = parseDateSafe(dateStr);
    if (!d) return '';
    return d.toLocaleString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };


  // Testimonials Carousel State & Autoplay Logic
  const testimonials = [
    {
      text: "PranaFlow Academy helped me choose the right course and learn with a structured live batch. The teacher guidance and support made my journey clear and confident.",
      stars: "★★★★★",
      name: "Emily W.",
      course: "200 Hour Yoga Teacher Training",
      location: "San Francisco, USA",
      avatar: getAssetUrl('assets/teacher_1.webp')
    },
    {
      text: "I was matched with an incredibly experienced teacher who corrected my postures and taught me traditional philosophy. Having PranaFlow handle the schedules and payments let me focus purely on my practice.",
      stars: "★★★★★",
      name: "Sarah C.",
      course: "300 Hour Yoga Teacher Training",
      location: "London, UK",
      avatar: getAssetUrl('assets/teacher_4.webp')
    },
    {
      text: "I truly loved the depth of yoga philosophy and alignment workshops. The support from enrollment to exams was outstanding. Highly recommend PranaFlow to every aspiring yoga teacher.",
      stars: "★★★★★",
      name: "Meera K.",
      course: "500 Hour Yoga TTC",
      location: "Munich, Germany",
      avatar: getAssetUrl('assets/teacher_2.webp')
    },
    {
      text: "The anatomical breakdowns and adjustments were so precise. I felt completely safe, guided, and structurally aware throughout my online classes. The student dashboard kept everything organized.",
      stars: "★★★★★",
      name: "David L.",
      course: "Certificate Course in Yoga",
      location: "Sydney, Australia",
      avatar: getAssetUrl('assets/teacher_5.webp')
    }
  ];

  const [slidesToShow, setSlidesToShow] = useState(3);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const totalDotsCount = Math.max(1, testimonials.length - slidesToShow + 1);

  const getSlidesToShow = () => {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 1024) return 2;
    return 3;
  };

  useEffect(() => {
    const handleResize = () => {
      const show = getSlidesToShow();
      setSlidesToShow(show);
      const maxIndex = testimonials.length - show;
      setActiveIndex(prev => Math.min(prev, maxIndex));
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(() => {
      const maxIndex = testimonials.length - slidesToShow;
      setActiveIndex(prev => {
        const next = prev + 1;
        return next > maxIndex ? 0 : next;
      });
    }, 6000);

    return () => clearInterval(interval);
  }, [isHovered, slidesToShow]);

  // FAQ Accordion State
  const [activeFaq, setActiveFaq] = useState(null);
  const toggleFaq = (index) => {
    setActiveFaq(prev => prev === index ? null : index);
  };

  const faqs = [
    {
      question: "Is PranaFlow Academy a yoga school or a learning platform?",
      answer: "PranaFlow Academy is a yoga and wellness learning platform that connects students with verified, experienced, and certified partner teachers. We manage course coordination, student enrollment, batch selection, dashboard access, fee process, and student support so teachers can focus on teaching."
    },
    {
      question: "Is PranaFlow Academy connected with Rishikesh?",
      answer: "Yes. PranaFlow Academy helps students access experienced partner teachers from Rishikesh and across India through structured online learning and guided enrollment support."
    },
    {
      question: "Who teaches the courses?",
      answer: "Courses are taught by selected partner teachers who are verified based on their experience, teaching quality, subject knowledge, and professional background."
    },
    {
      question: "Are your teachers Yoga Alliance certified?",
      answer: "Many of our partner teachers are Yoga Alliance certified or connected with Yoga Alliance registered or eligible training credentials, depending on the course. Each course page will clearly mention the teacher and certification details."
    },
    {
      question: "Will I receive a certificate after completing the course?",
      answer: "Yes, students receive a certificate after successfully completing the required course hours, attendance, assignments, exams, assessments, or other course requirements."
    },
    {
      question: "Who issues the certificate?",
      answer: "For Yoga Alliance registered or eligible teacher training courses, certificates are issued by the respective registered/certified partner teacher, partner school, or authorized training partner after successful completion. For PranaFlow Academy courses where external registration is not required, certificates are issued by PranaFlow Academy."
    },
    {
      question: "Is every course Yoga Alliance registered?",
      answer: "No. Not every course requires Yoga Alliance registration. Teacher training courses may be connected with Yoga Alliance registered or eligible partner credentials, while short courses, wellness courses, nutrition courses, workshops, and lifestyle programs may be certified by PranaFlow Academy."
    },
    {
      question: "Are classes live or recorded?",
      answer: "Our main courses are conducted through live online batches. Recorded class access may be provided where applicable, depending on the course and batch structure."
    },
    {
      question: "Can I join from outside India?",
      answer: "Yes. PranaFlow Academy is designed for students from India and around the world who want to learn yoga, wellness, lifestyle, and nutrition education online."
    },
    {
      question: "Can I pay in installments?",
      answer: "Yes, installment options may be available depending on the course policy. Students can check the fee structure before enrollment."
    },
    {
      question: "What if I have doubts before paying?",
      answer: "You can contact our team before enrolling or paying. We will help you understand course details, teacher information, batch timing, certificate process, fee options, installment plans, dashboard access, and exam requirements."
    },
    {
      question: "What happens after I enroll?",
      answer: "After enrollment and payment confirmation, you receive login access to your student dashboard where you can view your course, batch details, schedule, teacher information, exam updates, certificate information, and announcements."
    },
    {
      question: "What if I miss a live class?",
      answer: "Depending on the course and batch policy, recorded class access or support may be provided so students can stay updated with their batch learning."
    },
    {
      question: "Will there be an exam after course completion?",
      answer: "Yes, exams or assessments are conducted based on the course requirements. The format may vary depending on the course, teacher, and certification structure."
    },
    {
      question: "Can I become a yoga teacher after completing the course?",
      answer: "Our teacher training courses are designed to help students build the knowledge, confidence, and teaching skills needed to begin their yoga teaching journey. Your ability to teach professionally also depends on your practice, course completion, assessment, confidence, and local teaching requirements."
    }
  ];

  // Scroll to top and set SEO metadata
  useEffect(() => {
    document.title = "Yoga Teacher Training in Rishikesh | PranaFlow Academy";
    
    // Meta Description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', "PranaFlow Academy is a yoga training academy in Rishikesh, India, offering 200, 300 & 500 Hour Yoga Teacher Training, Kids Yoga, Face Yoga, wellness and online yoga courses with experienced teachers.");

    // Canonical Link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', "https://pranaflowacademy.com/");

    // Open Graph Metadata
    const ogTags = [
      { property: 'og:title', content: "Yoga Teacher Training in Rishikesh | PranaFlow Academy" },
      { property: 'og:description', content: "PranaFlow Academy is a yoga training academy in Rishikesh, India, offering professional yoga teacher training, online yoga courses and wellness education." },
      { property: 'og:type', content: "website" },
      { property: 'og:url', content: "https://pranaflowacademy.com/" },
      { property: 'og:image', content: "https://pranaflowacademy.com/assets/rishikesh_hero.webp" }
    ];

    ogTags.forEach(tag => {
      let el = document.querySelector(`meta[property="${tag.property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', tag.property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    // Twitter Metadata
    const twitterTags = [
      { name: 'twitter:card', content: "summary_large_image" },
      { name: 'twitter:title', content: "Yoga Teacher Training in Rishikesh | PranaFlow Academy" },
      { name: 'twitter:description', content: "Professional yoga teacher training and online yoga courses from PranaFlow Academy, Rishikesh, India." },
      { name: 'twitter:image', content: "https://pranaflowacademy.com/assets/rishikesh_hero.webp" }
    ];

    twitterTags.forEach(tag => {
      let el = document.querySelector(`meta[name="${tag.name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', tag.name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', tag.content);
    });

    window.scrollTo(0, 0);

    // Dynamic JSON-LD Schema Injection
    const scriptId = 'jsonld-schema-home';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": ["EducationalOrganization", "Organization"],
      "@id": "https://pranaflowacademy.com/#organization",
      "name": "PranaFlow Academy",
      "legalName": "PranaFlow Academy",
      "url": "https://pranaflowacademy.com/",
      "logo": "https://pranaflowacademy.com/assets/rishikesh_hero.webp",
      "description": "PranaFlow Academy is a yoga training academy in Rishikesh, India, offering 200, 300 & 500 Hour Yoga Teacher Training, Kids Yoga, Face Yoga, wellness and online yoga courses with experienced teachers.",
      "email": "pranaflowacademy@gmail.com",
      "telephone": "+919548354084",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Rishikesh",
        "addressRegion": "Uttarakhand",
        "postalCode": "249201",
        "addressCountry": "IN"
      },
      "areaServed": "Worldwide",
      "sameAs": [
        "https://www.youtube.com/@PranaFlow_Academy",
        "https://www.facebook.com/people/PranaFlow-Academy/61591081966434/",
        "https://www.instagram.com/pranaflowacademy/"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+919548354084",
        "contactType": "customer support",
        "email": "pranaflowacademy@gmail.com",
        "availableLanguage": ["English", "Hindi"]
      }
    };

    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://pranaflowacademy.com/#website",
      "url": "https://pranaflowacademy.com/",
      "name": "PranaFlow Academy",
      "publisher": {
        "@id": "https://pranaflowacademy.com/#organization"
      }
    };

    const webpageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://pranaflowacademy.com/#webpage",
      "url": "https://pranaflowacademy.com/",
      "name": "Yoga Teacher Training in Rishikesh | PranaFlow Academy",
      "description": "PranaFlow Academy is a yoga training academy in Rishikesh, India, offering 200, 300 & 500 Hour Yoga Teacher Training, Kids Yoga, Face Yoga, wellness and online yoga courses with experienced teachers.",
      "isPartOf": {
        "@id": "https://pranaflowacademy.com/#website"
      },
      "about": {
        "@id": "https://pranaflowacademy.com/#organization"
      }
    };

    script.textContent = JSON.stringify([organizationSchema, websiteSchema, webpageSchema]);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const handleHeroScroll = (targetId) => {
    const el = document.getElementById(targetId);
    if (!el) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const headerOffset = 88;
    const elementPosition = el.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  };

  return (
    <div className="public-site" style={{ backgroundColor: 'var(--bg-base)' }}>
      <PublicHeader />

      {/* =========================================================================
           1. HERO SECTION (Matches Reference web.PNG)
           ========================================================================= */}
      <section id="home" className="pf-hero-section">
        <div className="pf-hero-container">
          <div className="pf-hero-grid">
            {/* Left Column (~58%) */}
            <div className="pf-hero-content">
              {/* Eyebrow Pill */}
              <div className="pf-hero-eyebrow">
                <span className="pf-hero-eyebrow-dot" aria-hidden="true"></span>
                <span>PranaFlow Academy · Rishikesh, India</span>
              </div>

              {/* Main Heading H1 */}
              <h1 className="pf-hero-title">
                Yoga Teacher Training<br className="pf-hero-title-br" /> from Rishikesh
              </h1>

              {/* Supporting Line */}
              <p className="pf-hero-support-line">
                Learn with care. Build understanding. Grow into your teaching.
              </p>

              {/* Paragraph */}
              <p className="pf-hero-desc">
                We are a yoga school based in Rishikesh, the Yoga Capital of the World. We put the quality of your education first, with qualified teachers, clear explanations, and guided practice. Join our live online/offline courses to deepen your practice, begin your teacher training, or develop a specialist teaching skill.
              </p>

              {/* Four Trust Cards */}
              <div className="pf-hero-trust-grid">
                <div className="pf-hero-trust-card">
                  <span className="pf-hero-trust-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 3c-1.5 3-4 5.5-7 6.5 2.5 2 5 2 7-1 2 3 4.5 3 7 1-3-1-5.5-3.5-7-6.5zm-1 8c-2 2-5 3-8 3 2 2 4.5 2.5 7 1.5v5.5h2v-5.5c2.5 1 5 .5 7-1.5-3 0-6-1-8-3z"/>
                    </svg>
                  </span>
                  <span className="pf-hero-trust-text">Yoga Alliance–registered yoga teachers</span>
                </div>

                <div className="pf-hero-trust-card">
                  <span className="pf-hero-trust-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4 6a2 2 0 00-2 2v8a2 2 0 002 2h10a2 2 0 002-2v-2.5l4 2.5a1 1 0 001.5-.86V8.86a1 1 0 00-1.5-.86l-4 2.5V8a2 2 0 00-2-2H4z"/>
                    </svg>
                  </span>
                  <span className="pf-hero-trust-text">Live online classes</span>
                </div>

                <div className="pf-hero-trust-card">
                  <span className="pf-hero-trust-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="4.5" r="2.5" />
                      <path d="M12 8.5c-2.2 0-4.2.8-5.7 2.1-.5.4-.6 1.1-.2 1.6.4.5 1.1.6 1.6.2C9 11.2 10.4 10.5 12 10.5s3 .7 4.3 1.9c.5.4 1.2.3 1.6-.2.4-.5.3-1.2-.2-1.6-1.5-1.3-3.5-2.1-5.7-2.1z" />
                      <path d="M5.5 14c-1.1 0-2 .9-2 2 0 .8.5 1.5 1.2 1.8l3.3 1.3c.7.3 1.5.1 2-.4l2-2.2 2 2.2c.5.5 1.3.7 2 .4l3.3-1.3c.7-.3 1.2-1 1.2-1.8 0-1.1-.9-2-2-2-1 0-1.9.7-2 1.7l-2.5 1-1.5-1.7a2.5 2.5 0 00-3.6 0l-1.5 1.7-2.5-1c-.1-1-1-1.7-2-1.7z" />
                    </svg>
                  </span>
                  <span className="pf-hero-trust-text">Guided practice and learning support</span>
                </div>

                <div className="pf-hero-trust-card">
                  <span className="pf-hero-trust-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="9" r="6"/>
                      <path d="M9 9l2 2 4-4"/>
                      <path d="M8.2 14.5L7 21l5-2.5 5 2.5-1.2-6.5"/>
                    </svg>
                  </span>
                  <span className="pf-hero-trust-text">Clear course and certificate details</span>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="pf-hero-cta-group">
                <a
                  href="https://wa.me/919548354084?text=Hello%20PranaFlow%20Academy%2C%20I%20would%20like%20to%20know%20about%20the%20syllabus%2C%20course%20fees%2C%20and%20upcoming%20batch%20dates."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pf-hero-btn-primary"
                >
                  <span>Get Syllabus, Fees & Batch Dates</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </a>

                <button
                  type="button"
                  className="pf-hero-btn-secondary"
                  onClick={() => handleHeroScroll('programs')}
                >
                  <span>Explore Our Courses</span>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <line x1="12" y1="5" x2="12" y2="19"/>
                    <polyline points="19 12 12 19 5 12"/>
                  </svg>
                </button>
              </div>

              {/* Reassurance text */}
              <div className="pf-hero-reassurance">
                <span className="pf-hero-reassurance-icon" aria-hidden="true">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="9"/>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                </span>
                <span>
                  Tell us your goal. We will help you understand the course, schedule, and requirements before you enroll.
                </span>
              </div>
            </div>

            {/* Right Column (~40%): Frame & Photograph */}
            <div className="pf-hero-media">
              <div className="pf-hero-frame">
                <div className="pf-hero-img-wrap">
                  {/* Top-left location pill */}
                  <div className="pf-hero-loc-pill">
                    <span className="pf-hero-loc-icon" aria-hidden="true">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </span>
                    <span>Rishikesh, India</span>
                  </div>

                  {/* Main Portrait Image */}
                  <img
                    src={getAssetUrl("assets/pranaflow_hero_rishikesh.webp")}
                    alt="Yoga Teacher Training in Rishikesh, India by the Ganges"
                    className="pf-hero-img"
                    width="1254"
                    height="1254"
                    loading="eager"
                  />

                  {/* Lower Credential Panel (Temporarily hidden) */}
                  <div className="pf-hero-cred-panel" style={{ display: 'none' }} aria-hidden="true">
                    <div className="pf-hero-cred-left">
                      <div className="pf-hero-cred-icon" aria-hidden="true">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="8" r="5"/>
                          <path d="M8.5 13L6 21l6-3 6 3-2.5-8"/>
                        </svg>
                      </div>
                      <div>
                        <span className="pf-hero-cred-eyebrow">GLOBAL STANDARDS</span>
                        <span className="pf-hero-cred-title">Yoga Alliance Registered</span>
                      </div>
                    </div>
                    <span className="pf-hero-cred-tag">Rishikesh</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================================
           2. ABOUT PRANAFLOW ACADEMY
           ========================================================================= */}
      <section id="about" className="about section-padding" style={{ backgroundColor: 'var(--bg-surface-tint)' }}>
        <div className="container pf-grid-2">
          <div className="about-media">
            <div className="about-img-wrapper" style={{ borderRadius: 'var(--radius-lg)', overflow: 'hidden', boxShadow: 'var(--shadow-lg)' }}>
              <img src={getAssetUrl("assets/pranaflow_teaching_philosophy.webp")} alt="Yoga Teacher Training and Philosophy in Rishikesh India" style={{ width: '100%', height: '500px', objectFit: 'cover' }} />
            </div>
          </div>

          <div className="about-content">
            <span className="section-meta">Our Teaching Philosophy</span>
            <h2 className="section-title">Quality Comes First in Every Batch</h2>
            <p className="about-text" style={{ marginBottom: '16px' }}>
              Choosing a yoga course means trusting someone with your time, effort and learning. We take that responsibility seriously.
            </p>
            <p className="about-text" style={{ marginBottom: '16px' }}>
              At PranaFlow Academy, we believe in quality over quantity. We would rather run fewer well-supported batches than increase student numbers beyond our teaching capacity. We plan enrollment around the guidance, practice time and support we can responsibly provide.
            </p>
            <p className="about-text" style={{ marginBottom: '24px' }}>
              The same principle guides our teacher selection. We do not lower our standards to fill a teaching position or launch another batch. Relevant qualifications, subject knowledge and the ability to guide students patiently come first.
            </p>

            <HighlightCard
              icon="lotus"
              type="gold"
              text="Our measure of a successful course is the understanding you develop and the confidence you build through learning."
            />
          </div>
        </div>
      </section>


      {/* =========================================================================
           11. OUR YOGA PROGRAMS
           ========================================================================= */}
      <section id="programs" className="programs section-padding" style={{ backgroundColor: 'var(--bg-base)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '48px' }}>
            <h2 className="section-title">Explore Our Yoga Teacher Training and Specialist Courses</h2>
            <p className="section-desc" style={{ maxWidth: '800px' }}>
              Choose a foundation for your teaching journey, continue your training, or explore a specialist subject. Each course page explains the syllabus, entry requirements, learning format and certificate details so you can make an informed choice.
            </p>
          </div>

          <div className="pf-courses-ref-grid">
            {[
              {
                title: "200 Hour Yoga Teacher Training",
                slugMatch: "200",
                trainingHours: "200 Hours",
                defaultSchedule: "~1 Hour / Day Live Batches",
                description: "Build a foundation in asana, pranayama, meditation, yoga philosophy, anatomy and teaching methodology. Develop your personal practice while learning the principles of guiding a yoga class.",
                buttonText: "Explore 200 Hour Training",
                image: heroCourseImage200,
                link: "/courses/200-hour-yoga-teacher-training-rishikesh"
              },
              {
                title: "300 Hour Yoga Teacher Training",
                slugMatch: "300",
                trainingHours: "300 Hours",
                defaultSchedule: "~1 Hour / Day Live Batches",
                description: "Deepen your knowledge and refine your approach to teaching. Explore more detailed practice, sequencing and teaching methods while building on your previous training. Check the course entry requirements before applying.",
                buttonText: "Explore 300 Hour Training",
                image: heroCourseImage300,
                link: "/courses/300hr-yoga-ttc"
              },
              {
                title: "500 Hour Yoga Teacher Training",
                slugMatch: "500",
                trainingHours: "500 Hours",
                defaultSchedule: "~1 Hour / Day Live Batches",
                description: "Explore a comprehensive learning journey that brings foundational and advanced study together. Develop a broader understanding of yoga practice, philosophy and teaching through a structured training pathway.",
                buttonText: "Explore 500 Hour Training",
                image: heroCourseImage500,
                link: "/courses/500hr-yoga-ttc"
              }
            ].map((course, idx) => {
              const dbCourse = Array.isArray(coursesData) ? coursesData.find(c =>
                (c.title && c.title.toLowerCase().trim() === course.title.toLowerCase().trim()) ||
                (c.slug && c.slug.includes(course.slugMatch)) ||
                (c.title && c.title.includes(course.slugMatch))
              ) : null;

              const rawFee = dbCourse?.fee_inr !== undefined && dbCourse?.fee_inr !== null ? dbCourse.fee_inr : dbCourse?.fee;
              const isFeeNumeric = rawFee !== undefined && rawFee !== null && String(rawFee).trim() !== '' && !isNaN(Number(rawFee));
              const feeInr = isFeeNumeric ? Number(rawFee) : null;
              const isValidFee = isFeeNumeric && feeInr >= 0;
              const isFree = isValidFee && feeInr === 0;

              const coupon = isValidFee && !isFree ? getValidCouponForCourse(dbCourse) : null;
              const displayNormalPrice = isFree ? 'Free' : (isValidFee ? formatPrice(feeInr, dbCourse) : '');

              let hasDiscount = false;
              let formattedOriginalPrice = displayNormalPrice;
              let formattedDiscountedPrice = '';
              let percentageVal = 0;
              let couponCode = '';

              if (coupon && feeInr > 0) {
                if (coupon.discount_type === 'percentage') {
                  percentageVal = Math.round(parseFloat(coupon.discount_value));
                  if (percentageVal > 0 && percentageVal < 100) {
                    const discountedInr = Math.max(0, feeInr * (1 - percentageVal / 100));
                    formattedDiscountedPrice = formatPrice(discountedInr, dbCourse);
                    formattedOriginalPrice = formatPrice(feeInr, dbCourse);
                    hasDiscount = true;
                    couponCode = coupon.coupon_code;
                  }
                } else if (coupon.discount_type === 'flat' || coupon.discount_type === 'fixed') {
                  const fixedVal = parseFloat(coupon.discount_value);
                  if (fixedVal > 0 && fixedVal < feeInr) {
                    const discountedInr = Math.max(0, feeInr - fixedVal);
                    percentageVal = Math.round((fixedVal / feeInr) * 100);
                    formattedDiscountedPrice = formatPrice(discountedInr, dbCourse);
                    formattedOriginalPrice = formatPrice(feeInr, dbCourse);
                    hasDiscount = true;
                    couponCode = coupon.coupon_code;
                  }
                }
              }


              const expiryDateStr = coupon ? (coupon.banner_expiry || coupon.expiry_date || null) : null;
              const countdownStr = expiryDateStr ? formatCountdown(expiryDateStr) : '';
              const showCountdown = !!(expiryDateStr && countdownStr && countdownStr !== 'Offer ended.');

              const durationBadge = dbCourse?.duration ? dbCourse.duration.split('/')[0].trim() : course.trainingHours;

              return (
                <div className="pf-ref-course-card" key={idx}>
                  <div className="pf-ref-card-img-wrap">
                    <img src={course.image} alt={course.title} className="pf-ref-card-img" />
                    <span className="pf-ref-badge-duration">{durationBadge}</span>
                  </div>

                  <div className="pf-ref-card-body">
                    <h3 className="pf-ref-card-title">{course.title}</h3>
                    <p className="pf-ref-card-desc">{course.description}</p>

                    {/* Light Cream Pricing Panel */}
                    <div className="pf-ref-pricing-panel">
                      {coursesLoading ? (
                        <div className="pf-ref-price-single" style={{ fontSize: '1.15rem' }}>
                          Loading...
                        </div>
                      ) : !isValidFee ? (
                        <div className="pf-ref-price-single" style={{ fontSize: '1.15rem' }}>
                          Fee will be updated soon.
                        </div>
                      ) : isFree ? (
                        <div>
                          <span className="pf-ref-price-label">COURSE TUITION FEE</span>
                          <div className="pf-ref-price-single">Free</div>
                        </div>
                      ) : hasDiscount ? (
                        <div>
                          <div className="pf-ref-price-badge-row">
                            <span className="pf-ref-price-badge">SPECIAL OFFER · {percentageVal}% OFF</span>
                          </div>
                          <div className="pf-ref-price-amount-row">
                            <span className="pf-ref-price-orig">{formattedOriginalPrice}</span>
                            <span className="pf-ref-price-disc">{formattedDiscountedPrice}</span>
                          </div>
                          {showCountdown && (
                            <div className="pf-courses-countdown">
                              <div className="pf-courses-countdown-until">
                                Offer valid until: {formatExpiryDisplay(expiryDateStr)}
                              </div>
                              <div className="pf-courses-countdown-timer">
                                <span className="pf-courses-countdown-label">Offer ends in:</span>
                                <span className="pf-courses-countdown-digits">{countdownStr}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          <span className="pf-ref-price-label">COURSE TUITION FEE</span>
                          <div className="pf-ref-price-single">{displayNormalPrice}</div>
                        </div>
                      )}
                    </div>

                    {/* Compact Information Rows */}
                    <div className="pf-ref-info-rows">
                      <div className="pf-ref-info-row">
                        <span className="pf-ref-info-icon">
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                            <line x1="8" y1="21" x2="16" y2="21"/>
                            <line x1="12" y1="17" x2="12" y2="21"/>
                          </svg>
                        </span>
                        <span className="pf-ref-info-text">Live Online & Classroom Training</span>
                      </div>
                      <div className="pf-ref-info-row">
                        <span className="pf-ref-info-icon">
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"/>
                            <polyline points="12 6 12 12 16 14"/>
                          </svg>
                        </span>
                        <span className="pf-ref-info-text">{course.trainingHours} Training</span>
                      </div>
                    </div>

                    <div className="pf-course-promo-badge">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                        <line x1="7" y1="7" x2="7.01" y2="7"></line>
                      </svg>
                      <span>Every batch: First 5 students get an extra discount on fee!</span>
                    </div>

                    {/* Pill Button */}
                    <Link to={course.link} className="pf-ref-card-btn">
                      <span>{course.buttonText}</span>
                      <span className="pf-ref-card-btn-icon">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M7 17L17 7M17 7H7M17 7V17" />
                        </svg>
                      </span>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Specialist Courses Group */}
          <div style={{ marginTop: '56px' }}>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: 'var(--primary)', marginBottom: '24px', textAlign: 'center' }}>
              Specialist Certification Programs
            </h3>
            <div className="pf-courses-ref-grid">
              {[
                {
                  title: "Kids Yoga Teacher Training",
                  dbTitle: "95-Hour Kids Yoga Teacher Training",
                  courseId: 10,
                  slugMatch: "kids",
                  trainingHours: "95 Hours",
                  defaultSchedule: "~1 Hour / Day Live Batches",
                  description: "A specialized course for learning safe, creative, and engaging yoga teaching methods for children through movement, play, breathing, mindfulness, and age-appropriate practices.",
                  buttonText: "Explore Kids Yoga Training",
                  image: heroCourseImageKids,
                  link: "/courses/95-hour-kids-yoga-teacher-training"
                },
                {
                  title: "Diet and Nutrition Course",
                  dbTitle: "Diet and Nutrition Course",
                  courseId: 8,
                  slugMatch: "diet",
                  trainingHours: "1 Month",
                  defaultSchedule: "~1 Hour / Day Live Batches",
                  description: "A practical wellness-focused course designed to help students understand nutrition basics, healthy eating habits, yogic lifestyle, and diet planning for better well-being.",
                  buttonText: "Explore Nutrition Course",
                  image: heroCourseImageDiet,
                  link: "/courses/diet-and-nutrition-course-online"
                },
                {
                  title: "Face Yoga Teacher Training Course",
                  dbTitle: "Face Yoga Teacher Training Course",
                  courseId: 9,
                  slugMatch: "face",
                  trainingHours: "30 Hours",
                  defaultSchedule: "~1 Hour / Day Live Batches",
                  description: "A specialized teacher training course focused on face yoga techniques, facial exercises, relaxation practices, natural wellness, and teaching methods for face yoga sessions.",
                  buttonText: "Explore Face Yoga Training",
                  image: heroCourseImageFace,
                  link: "/courses/face-yoga-teacher-training-course-online"
                }
              ].map((course, idx) => {
                const dbCourse = Array.isArray(coursesData) ? coursesData.find(c =>
                  (course.courseId && Number(c.id) === Number(course.courseId)) ||
                  (c.title && course.title && c.title.toLowerCase().trim() === course.title.toLowerCase().trim()) ||
                  (c.title && course.dbTitle && c.title.toLowerCase().trim() === course.dbTitle.toLowerCase().trim()) ||
                  (course.slugMatch && (
                    (c.slug && c.slug.includes(course.slugMatch)) ||
                    (c.course_slug && c.course_slug.includes(course.slugMatch)) ||
                    (c.title && c.title.toLowerCase().includes(course.slugMatch.toLowerCase()))
                  ))
                ) : null;

                const rawFee = dbCourse?.fee_inr !== undefined && dbCourse?.fee_inr !== null ? dbCourse.fee_inr : dbCourse?.fee;
                const isFeeNumeric = rawFee !== undefined && rawFee !== null && String(rawFee).trim() !== '' && !isNaN(Number(rawFee));
                const feeInr = isFeeNumeric ? Number(rawFee) : null;
                const isValidFee = isFeeNumeric && feeInr >= 0;
                const isFree = isValidFee && feeInr === 0;

                const coupon = isValidFee && !isFree ? getValidCouponForCourse(dbCourse) : null;
                const displayNormalPrice = isFree ? 'Free' : (isValidFee ? formatPrice(feeInr, dbCourse) : '');

                let hasDiscount = false;
                let formattedOriginalPrice = displayNormalPrice;
                let formattedDiscountedPrice = '';
                let percentageVal = 0;
                let couponCode = '';

                if (coupon && feeInr > 0) {
                  if (coupon.discount_type === 'percentage') {
                    percentageVal = Math.round(parseFloat(coupon.discount_value));
                    if (percentageVal > 0 && percentageVal < 100) {
                      const discountedInr = Math.max(0, feeInr * (1 - percentageVal / 100));
                      formattedDiscountedPrice = formatPrice(discountedInr, dbCourse);
                      formattedOriginalPrice = formatPrice(feeInr, dbCourse);
                      hasDiscount = true;
                      couponCode = coupon.coupon_code;
                    }
                  } else if (coupon.discount_type === 'flat' || coupon.discount_type === 'fixed') {
                    const fixedVal = parseFloat(coupon.discount_value);
                    if (fixedVal > 0 && fixedVal < feeInr) {
                      const discountedInr = Math.max(0, feeInr - fixedVal);
                      percentageVal = Math.round((fixedVal / feeInr) * 100);
                      formattedDiscountedPrice = formatPrice(discountedInr, dbCourse);
                      formattedOriginalPrice = formatPrice(feeInr, dbCourse);
                      hasDiscount = true;
                      couponCode = coupon.coupon_code;
                    }
                  }
                }


                const expiryDateStr = coupon ? (coupon.banner_expiry || coupon.expiry_date || null) : null;
                const countdownStr = expiryDateStr ? formatCountdown(expiryDateStr) : '';
                const showCountdown = !!(expiryDateStr && countdownStr && countdownStr !== 'Offer ended.');

                const rawDuration = dbCourse?.duration ? dbCourse.duration.split('/')[0].trim() : course.trainingHours;
                const durationBadge = rawDuration.toLowerCase() === '1 months' ? '1 Month' : rawDuration;

                return (
                  <div className="pf-ref-course-card" key={`specialist-${idx}`}>
                    <div className="pf-ref-card-img-wrap">
                      <img src={course.image} alt={course.title} className="pf-ref-card-img" />
                      <span className="pf-ref-badge-duration">{durationBadge}</span>
                    </div>

                    <div className="pf-ref-card-body">
                      <h3 className="pf-ref-card-title">{course.title}</h3>
                      <p className="pf-ref-card-desc">{course.description}</p>

                      {/* Light Cream Pricing Panel */}
                      <div className="pf-ref-pricing-panel">
                        {coursesLoading ? (
                          <div className="pf-ref-price-single" style={{ fontSize: '1.15rem' }}>
                            Loading...
                          </div>
                        ) : !isValidFee ? (
                          <div className="pf-ref-price-single" style={{ fontSize: '1.15rem' }}>
                            Fee will be updated soon.
                          </div>
                        ) : isFree ? (
                          <div>
                            <span className="pf-ref-price-label">COURSE TUITION FEE</span>
                            <div className="pf-ref-price-single">Free</div>
                          </div>
                        ) : hasDiscount ? (
                          <div>
                            <div className="pf-ref-price-badge-row">
                              <span className="pf-ref-price-badge">SPECIAL OFFER · {percentageVal}% OFF</span>
                            </div>
                            <div className="pf-ref-price-amount-row">
                              <span className="pf-ref-price-orig">{formattedOriginalPrice}</span>
                              <span className="pf-ref-price-disc">{formattedDiscountedPrice}</span>
                            </div>
                            {showCountdown && (
                              <div className="pf-courses-countdown">
                                <div className="pf-courses-countdown-until">
                                  Offer valid until: {formatExpiryDisplay(expiryDateStr)}
                                </div>
                                <div className="pf-courses-countdown-timer">
                                  <span className="pf-courses-countdown-label">Offer ends in:</span>
                                  <span className="pf-courses-countdown-digits">{countdownStr}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            <span className="pf-ref-price-label">COURSE TUITION FEE</span>
                            <div className="pf-ref-price-single">{displayNormalPrice}</div>
                          </div>
                        )}
                      </div>

                      {/* Compact Information Rows */}
                      <div className="pf-ref-info-rows">
                        <div className="pf-ref-info-row">
                          <span className="pf-ref-info-icon">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                              <line x1="8" y1="21" x2="16" y2="21"/>
                              <line x1="12" y1="17" x2="12" y2="21"/>
                            </svg>
                          </span>
                          <span className="pf-ref-info-text">Live Online & Classroom Training</span>
                        </div>
                        <div className="pf-ref-info-row">
                          <span className="pf-ref-info-icon">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <circle cx="12" cy="12" r="10"/>
                              <polyline points="12 6 12 12 16 14"/>
                            </svg>
                          </span>
                          <span className="pf-ref-info-text">{course.trainingHours} Training</span>
                        </div>
                      </div>

                      <div className="pf-course-promo-badge">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                          <line x1="7" y1="7" x2="7.01" y2="7"></line>
                        </svg>
                        <span>Every batch: First 5 students get an extra discount on fee!</span>
                      </div>

                      {/* Pill Button */}
                      <Link to={course.link} className="pf-ref-card-btn">
                        <span>{course.buttonText}</span>
                        <span className="pf-ref-card-btn-icon">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <path d="M7 17L17 7M17 7H7M17 7V17" />
                          </svg>
                        </span>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="text-center" style={{ marginTop: '48px' }}>
            <Link to="/courses" className="btn btn-primary">View All Yoga Courses</Link>
          </div>
        </div>
      </section>

      {/* =========================================================================
           7. TEACHER VERIFICATION SECTION
           ========================================================================= */}
      <section className="section-padding" style={{ backgroundColor: 'var(--bg-base)' }}>
        <div className="container">
          <div className="pf-grid-2">
            <div>
              <span className="section-meta">Our School and Faculty Standards</span>
              <h2 className="section-title">Rooted in Rishikesh. Committed to Quality Education.</h2>
              <p className="about-text" style={{ marginBottom: '16px' }}>
                For us, being a yoga school in Rishikesh carries a responsibility: to teach with care, respect the depth of yoga, and give students a sound understanding of their practice. That responsibility begins with who teaches you.
              </p>
              <p className="about-text" style={{ marginBottom: '16px' }}>
                We select only teachers with relevant, verifiable qualifications for the subjects they teach. Our yoga teachers must hold an active Yoga Alliance registration or relevant qualifications from reputable, government-recognized institutions. Teachers of specialist subjects, such as nutrition or face yoga, must have appropriate qualifications and expertise in their own field.
              </p>
              <p className="about-text" style={{ marginBottom: '24px' }}>
                A qualification is only the starting point. We also look for teaching experience, patient communication, and the ability to explain the purpose of a practice, answer questions clearly, and guide students at the right level. These qualities turn a syllabus into a learning experience that builds real understanding and confidence.
              </p>
            </div>

            <div style={{ backgroundColor: 'var(--bg-surface-tint)', padding: '36px 32px', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)' }}>
              <h3 style={{ color: 'var(--primary)', marginBottom: '20px', fontWeight: '800', fontSize: '1.25rem', display: 'flex', gap: '10px', alignItems: 'center' }}>
                <span style={{ width: '24px', height: '24px', color: 'var(--primary)', display: 'inline-flex' }}>{Icons.verify}</span>
                Our Selection Focus
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
                {[
                  {
                    label: "Relevant credentials:",
                    desc: "Qualifications and registration details appropriate to the subject."
                  },
                  {
                    label: "Subject knowledge:",
                    desc: "A sound understanding of the course they will teach."
                  },
                  {
                    label: "Teaching experience:",
                    desc: "A background suited to the program and its learners."
                  },
                  {
                    label: "Clear communication:",
                    desc: "The ability to explain, demonstrate and respond to questions."
                  },
                  {
                    label: "Respectful guidance:",
                    desc: "Patience, professionalism and consideration for different learning needs."
                  }
                ].map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      background: '#ffffff',
                      padding: '14px 16px',
                      borderRadius: 'var(--radius-sm)',
                      border: '1px solid var(--border-light)',
                      display: 'flex',
                      gap: '12px',
                      alignItems: 'flex-start',
                      fontSize: '0.875rem',
                      color: 'var(--text-body)',
                      lineHeight: '1.5',
                      boxShadow: 'var(--shadow-sm)'
                    }}
                  >
                    <span style={{ color: '#4CAF50', display: 'inline-flex', marginTop: '2px', flexShrink: 0 }}>
                      {Icons.check}
                    </span>
                    <div>
                      <strong style={{ color: 'var(--primary)', fontWeight: '700' }}>{item.label}</strong>{' '}
                      <span>{item.desc}</span>
                    </div>
                  </div>
                ))}
              </div>

              <HighlightCard
                icon="verify"
                type="green"
                text="Before you enroll, ask us about the teacher assigned to your batch and their relevant credentials."
                style={{
                  marginTop: '0',
                  marginBottom: '20px',
                  backgroundColor: '#ffffff',
                  border: '1px solid var(--border-light)',
                  borderLeft: '5px solid #4CAF50',
                  padding: '16px 18px',
                  gap: '12px'
                }}
              />

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleHeroScroll(document.getElementById('enquiry-form') ? 'enquiry-form' : 'cta')}
                style={{
                  width: '100%',
                  justifyContent: 'center',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer'
                }}
              >
                <span>Ask About Your Course Teacher</span>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <line x1="12" y1="5" x2="12" y2="19"/>
                  <polyline points="19 12 12 19 5 12"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* =========================================================================
           10. WHY STUDENTS CHOOSE PRANAFLOW ACADEMY
           ========================================================================= */}
      <section className="section-padding pf-why-section" id="why-choose" style={{ backgroundColor: '#ffffff' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '40px' }}>
            <span className="section-meta">Why Choose Us</span>
            <h2 className="section-title">Quality Teaching, Clear Process, Complete Support</h2>
            <p className="section-desc">PranaFlow Academy is built for students who want genuine yoga education, not just attractive marketing.</p>
          </div>

          <div className="pf-why-grid">
            <ul className="pf-why-col pf-why-col--left">
              <li className="pf-why-point">
                <div className="pf-why-point-text">
                  <h3>Verified Partner Teachers</h3>
                  <p>We carefully select teachers based on experience, knowledge, teaching quality, and course suitability.</p>
                </div>
                <span className="pf-why-point-icon" aria-hidden="true">
                  <img src={getAssetUrl("assets/why-choose/certified.webp")} alt="Verified Partner Teachers icon" width="70" height="70" />
                </span>
              </li>
              <li className="pf-why-point">
                <div className="pf-why-point-text">
                  <h3>Rishikesh-Connected Learning</h3>
                  <p>Students can learn from experienced teachers connected with Rishikesh and traditional yoga education.</p>
                </div>
                <span className="pf-why-point-icon" aria-hidden="true">
                  <img src={getAssetUrl("assets/why-choose/rooted-tradition.webp")} alt="Rishikesh-Connected Learning icon" width="70" height="70" />
                </span>
              </li>
              <li className="pf-why-point">
                <div className="pf-why-point-text">
                  <h3>Structured Live Batches</h3>
                  <p>Students learn in proper live batches with a clear schedule and guided course flow.</p>
                </div>
                <span className="pf-why-point-icon" aria-hidden="true">
                  <img src={getAssetUrl("assets/why-choose/small-batches.webp")} alt="Structured Live Batches icon" width="70" height="70" />
                </span>
              </li>
              <li className="pf-why-point">
                <div className="pf-why-point-text">
                  <h3>Student Dashboard Access</h3>
                  <p>After enrollment, students receive dashboard access to view course details, batch updates, teacher info, and certificates.</p>
                </div>
                <span className="pf-why-point-icon" aria-hidden="true">
                  <img src={getAssetUrl("assets/why-choose/instant-confirmation.webp")} alt="Student Dashboard Access icon" width="70" height="70" />
                </span>
              </li>
            </ul>

            <div className="pf-why-media">
              <img className="pf-why-flower" src={getAssetUrl("assets/why-choose/surya-chakara.webp")} alt="Decorative mandala pattern" width="507" height="347" aria-hidden="true" />
              <img className="pf-why-figure" src={getAssetUrl("assets/why-choose/pranaflow-girl-character.webp")} alt="Student meditating in lotus pose" width="1208" height="1302" />
            </div>

            <ul className="pf-why-col pf-why-col--right">
              <li className="pf-why-point">
                <span className="pf-why-point-icon" aria-hidden="true">
                  <img src={getAssetUrl("assets/why-choose/traditional-lineage.webp")} alt="Transparent Certification icon" width="70" height="70" />
                </span>
                <div className="pf-why-point-text">
                  <h3>Transparent Certification</h3>
                  <p>We clearly explain who will issue the certificate and what type of certificate students will receive.</p>
                </div>
              </li>
              <li className="pf-why-point">
                <span className="pf-why-point-icon" aria-hidden="true">
                  <img src={getAssetUrl("assets/why-choose/world-wide-support.webp")} alt="Support Before Payment icon" width="70" height="70" />
                </span>
                <div className="pf-why-point-text">
                  <h3>Support Before Payment</h3>
                  <p>Students can contact us before enrolling to understand course details, batch timing, fee options, and teacher credentials.</p>
                </div>
              </li>
              <li className="pf-why-point">
                <span className="pf-why-point-icon" aria-hidden="true">
                  <img src={getAssetUrl("assets/why-choose/balance-energy.webp")} alt="Quality-Focused Education icon" width="70" height="70" />
                </span>
                <div className="pf-why-point-text">
                  <h3>Quality-Focused Education</h3>
                  <p>Our aim is to help students become confident and knowledgeable, not just certificate holders.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* =========================================================================
           12. LIVE ONLINE LEARNING EXPERIENCE
           ========================================================================= */}
      <section className="section-padding pf-live-classes-section" style={{ backgroundColor: 'var(--bg-surface-tint)' }}>
        <div className="container pf-grid-2-wide" style={{ alignItems: 'start' }}>
          <div className="online-media">
            <div className="online-img-wrapper">
              <img src={getAssetUrl("assets/pranaflow_live_online_class.webp")} alt="Student attending live online yoga class" />
            </div>
          </div>

          <div>
            <span className="section-meta">Live Classes</span>
            <h2 className="section-title" style={{ marginBottom: '20px' }}>Live Online Learning with Space for Your Questions</h2>
            <p className="about-text" style={{ marginBottom: '16px' }}>
              Can't travel to Rishikesh or India right now? You can still begin your yoga journey through structured live online classes with experienced partner teachers.
            </p>
            <p className="about-text" style={{ marginBottom: '28px' }}>
              You won't be learning alone through random videos. You learn with a teacher, a batch, a schedule, and a clear learning path. Join scheduled classes, learn directly from your teacher, and develop your understanding through guided practice and discussion.
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginBottom: '32px' }}>
              {[
                {
                  title: "A clear learning schedule",
                  desc: "Follow your batch timetable and see how the course progresses, so you can make time for classes and personal practice.",
                  icon: Icons.calendar
                },
                {
                  title: "Guidance from your teacher",
                  desc: "Ask questions, explore the reasoning behind techniques, and receive guidance suited to your course and the online format.",
                  icon: Icons.teacher
                },
                {
                  title: "A student dashboard",
                  desc: "Access your course details, batch updates, schedules, and announcements in one place.",
                  icon: Icons.dashboard
                },
                {
                  title: "A team you can contact",
                  desc: "Reach out for help with enrollment, batch information, access questions, and course completion guidance.",
                  icon: Icons.support
                }
              ].map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    backgroundColor: '#ffffff',
                    padding: '20px 22px',
                    borderRadius: 'var(--radius-md)',
                    border: '1px solid var(--border-light)',
                    boxShadow: 'var(--shadow-sm)'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ color: 'var(--secondary)', display: 'inline-flex', flexShrink: 0, width: '22px', height: '22px' }}>
                      {item.icon}
                    </span>
                    <h3 style={{ fontSize: '1rem', fontWeight: '800', color: 'var(--primary)', margin: 0, lineHeight: '1.3' }}>
                      {item.title}
                    </h3>
                  </div>
                  <p style={{ fontSize: '0.875rem', color: 'var(--text-body)', lineHeight: '1.55', margin: 0 }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>

            <h3 style={{ fontSize: '1.2rem', fontWeight: '800', color: 'var(--primary)', marginBottom: '16px' }}>
              What Your Online Learning Includes
            </h3>
            <ul className="pf-checklist-grid" style={{ marginBottom: '28px', listStyle: 'none', padding: 0 }}>
              {[
                "Live online classes",
                "Structured batch schedule",
                "Teacher interaction",
                "Doubt support",
                "Course materials",
                "Recorded class access",
                "Student dashboard access",
                "Batch-wise learning flow",
                "Exam and assessment updates",
                "Completion support"
              ].map((item, idx) => (
                <li key={idx} style={{ display: 'flex', gap: '8px', alignItems: 'center', fontSize: '0.9rem', color: 'var(--text-primary)', fontWeight: '700' }}>
                  <span style={{ color: 'var(--secondary)', display: 'inline-flex', flexShrink: 0 }}>{Icons.check}</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <p className="about-text" style={{ marginBottom: '16px', fontSize: '0.95rem' }}>
              You are welcome to ask questions and share where you need more explanation. Learning takes practice, and your starting point deserves respect.
            </p>

            <HighlightCard
              icon="lotus"
              type="gold"
              text="Our aim is to help you become a teacher who understands yoga deeply — not just someone who holds a certificate."
              style={{ marginTop: '0' }}
            />
          </div>
        </div>
      </section>


      {/* =========================================================================
           14. CERTIFICATION SECTION
           ========================================================================= */}
      <section className="section-padding" style={{ backgroundColor: 'var(--bg-surface-tint)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '48px' }}>
            <span className="section-meta">Credentials</span>
            <h2 className="section-title">Certification with Clear and Honest Guidance</h2>
            <p className="section-desc">At PranaFlow Academy, we believe students should clearly understand what certificate they will receive before joining any course.</p>
          </div>

          <div className="certification-grid">
            <div className="certification-card" style={{ borderTop: '4px solid var(--primary)' }}>
              <span className="pf-cert-tag">Registered Eligible</span>
              <h3 style={{ fontSize: '1.25rem', marginTop: '4px' }}>Yoga Alliance Courses</h3>
              <p>
                For Yoga Alliance registered or eligible teacher training courses, certificates are issued by the respective registered/certified partner teacher, partner school, or authorized training partner after successful completion.
              </p>
              <p style={{ marginTop: '16px', fontSize: '0.85rem', color: 'var(--text-light)', fontStyle: 'italic' }}>
                * Students must complete the required learning hours, attendance, assignments, practical learning, exams, and assessments.
              </p>
            </div>

            <div className="certification-card" style={{ borderTop: '4px solid var(--secondary)' }}>
              <span className="pf-cert-tag">Academy Certified</span>
              <h3 style={{ fontSize: '1.25rem', marginTop: '4px' }}>PranaFlow Academy Courses</h3>
              <p>
                Some courses do not require Yoga Alliance registration or external registration. These may include wellness, lifestyle, and nutrition courses, short-term yoga programs, foundation courses, workshops, and skill-based learning.
              </p>
              <p style={{ marginTop: '16px', fontSize: '0.85rem', color: 'var(--text-light)', fontStyle: 'italic' }}>
                * For such courses, certificates are issued by <strong>PranaFlow Academy</strong> after successful completion of requirements.
              </p>
            </div>

            <div className="certification-card" style={{ borderTop: '4px solid #4CAF50' }}>
              <span className="pf-cert-tag">Transparent Policies</span>
              <h3 style={{ fontSize: '1.25rem', marginTop: '4px' }}>Certificate Promise</h3>
              <p>Before enrollment, students will clearly know:</p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', fontSize: '0.9rem', color: 'var(--text-body)' }}>
                  <span style={{ color: 'var(--secondary)' }}>✓</span> Who is teaching the course
                </li>
                <li style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', fontSize: '0.9rem', color: 'var(--text-body)' }}>
                  <span style={{ color: 'var(--secondary)' }}>✓</span> Who will issue the certificate
                </li>
                <li style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', fontSize: '0.9rem', color: 'var(--text-body)' }}>
                  <span style={{ color: 'var(--secondary)' }}>✓</span> Yoga Alliance credential status
                </li>
                <li style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', fontSize: '0.9rem', color: 'var(--text-body)' }}>
                  <span style={{ color: 'var(--secondary)' }}>✓</span> Required completion criteria
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center" style={{ marginTop: '40px', maxWidth: '650px', margin: '40px auto 0 auto' }}>
            <HighlightCard
              icon="certificate"
              type="teal"
              text="Our goal is not to confuse students with false promises. Our goal is to provide transparent, trusted, and quality education."
            />
          </div>
        </div>
      </section>

      {/* =========================================================================
           15. WHAT YOU WILL GAIN
           ========================================================================= */}
      <section className="section-padding" style={{ backgroundColor: 'var(--bg-base)' }}>
        <div className="container">
          <div className="pf-grid-2-wide">
            <div>
              <span className="section-meta">Learn with Support</span>
              <h2 className="section-title">Live Online Learning with Space for Your Questions</h2>
              <p className="about-text" style={{ marginBottom: '16px' }}>
                Learning online should feel personal and well organized. Join scheduled classes, learn directly from your teacher, and develop your understanding through guided practice and discussion.
              </p>
              <p className="about-text" style={{ marginBottom: '24px' }}>
                You are welcome to ask questions and share where you need more explanation. Learning takes practice, and your starting point deserves respect.
              </p>

              <HighlightCard
                icon="lotus"
                type="gold"
                text="Our aim is to help you become a teacher who understands yoga deeply — not just someone who holds a certificate."
              />
            </div>

            <div style={{ backgroundColor: 'var(--bg-surface)', padding: '36px 32px', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-sm)' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {[
                  {
                    title: "A clear learning schedule",
                    desc: "Follow your batch timetable and understand how the course progresses, so you can make time for classes and personal practice.",
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                      </svg>
                    )
                  },
                  {
                    title: "Guidance from your teacher",
                    desc: "Ask questions, explore the reasoning behind techniques and receive guidance appropriate to the course and online format.",
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 00-3-3.87" />
                        <path d="M16 3.13a4 4 0 010 7.75" />
                      </svg>
                    )
                  },
                  {
                    title: "A student dashboard",
                    desc: "Access your course and batch information, schedules and announcements in one place. Materials and class recordings are available where included in your chosen program.",
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="3" y="3" width="7" height="9" rx="1" />
                        <rect x="14" y="3" width="7" height="5" rx="1" />
                        <rect x="14" y="12" width="7" height="9" rx="1" />
                        <rect x="3" y="16" width="7" height="5" rx="1" />
                      </svg>
                    )
                  },
                  {
                    title: "A team you can contact",
                    desc: "Reach out for help with enrollment, batch information, access questions and course completion guidance.",
                    icon: (
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M3 18v-6a9 9 0 0118 0v6" />
                        <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" />
                      </svg>
                    )
                  }
                ].map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      background: '#ffffff',
                      padding: '18px 20px',
                      borderRadius: 'var(--radius-md)',
                      border: '1px solid var(--border-light)',
                      boxShadow: 'var(--shadow-sm)',
                      display: 'flex',
                      gap: '16px',
                      alignItems: 'flex-start'
                    }}
                  >
                    <span style={{
                      color: 'var(--secondary)',
                      display: 'inline-flex',
                      marginTop: '2px',
                      flexShrink: 0
                    }}>
                      {item.icon}
                    </span>
                    <div>
                      <h3 style={{
                        fontSize: '1.05rem',
                        fontWeight: '700',
                        color: 'var(--primary)',
                        marginBottom: '6px',
                        lineHeight: '1.3'
                      }}>
                        {item.title}
                      </h3>
                      <p style={{
                        fontSize: '0.875rem',
                        color: 'var(--text-body)',
                        lineHeight: '1.55',
                        margin: 0
                      }}>
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================================================
           17. REVIEWS SECTION (COMMENTED OUT FOR NOW)
           ========================================================================= */}
      {/*
      <section id="reviews" className="testimonials section-padding" style={{ backgroundColor: 'var(--bg-base)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '48px' }}>
            <span className="section-meta">Reviews</span>
            <h2 className="section-title">What Our Students Say</h2>
            <p className="section-desc">Real student feedback will be shared here as our community grows. We believe real trust is built through real student experiences, honest reviews, and visible transformation.</p>
          </div>

          <div
            className="testimonials-carousel"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="testimonials-track-container">
              <div
                className="testimonials-track"
                style={{
                  transform: `translateX(-${activeIndex * (100 / slidesToShow)}%)`
                }}
              >
                {testimonials.map((t, idx) => (
                  <div className="testimonial-card" key={idx}>
                    <div className="testimonial-bubble">
                      <span className="quote-icon">"</span>
                      <p className="testimonial-text">{t.text}</p>
                      <div className="testimonial-stars">{t.stars}</div>
                    </div>
                    <div className="testimonial-user">
                      <img src={t.avatar} alt={t.name} className="testimonial-avatar" />
                      <div>
                        <h4 className="testimonial-name">{t.name}</h4>
                        <p className="testimonial-role">{t.course}</p>
                        <p className="testimonial-role" style={{ color: 'var(--secondary)', fontWeight: 'normal' }}>{t.location}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="carousel-dots">
              {Array.from({ length: totalDotsCount }).map((_, idx) => (
                <div
                  key={idx}
                  className={`dot ${activeIndex === idx ? 'active' : ''}`}
                  onClick={() => setActiveIndex(idx)}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </section>
      */}


      {/* =========================================================================
           20. FAQ SECTION
           ========================================================================= */}
      <section id="faq" className="faq section-padding" style={{ backgroundColor: 'var(--bg-base)' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '48px' }}>
            <span className="section-meta">FAQs</span>
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="section-desc">Have questions about courses, certifications, batch structures, or dashboard access? Find your answers here.</p>
          </div>

          <div className="pf-faq-accordion-container">
            {faqs.map((f, idx) => (
              <FaqCard
                key={idx}
                question={f.question}
                answer={f.answer}
                isActive={activeFaq === idx}
                onToggle={() => toggleFaq(idx)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* =========================================================================
           21. FINAL CALL-TO-ACTION SECTION
           ========================================================================= */}
      <section id="cta" className="cta-banner" style={{ paddingBottom: '80px' }}>
        <div className="container">
          <div className="cta-banner-wrapper" style={{ padding: '60px 48px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '32px' }}>
            <div style={{ maxWidth: '800px' }}>
              <h2 style={{ color: '#ffffff', fontSize: '2.25rem', fontWeight: '800', marginBottom: '16px' }}>
                Ready to Start Your Yoga Journey with PranaFlow Academy?
              </h2>
              <p style={{ color: 'var(--bg-sage)', fontSize: '1.05rem', lineHeight: '1.6', marginBottom: '16px' }}>
                You do not have to figure everything out alone. Tell us what you want to learn, choose your course, select your batch, and begin your training with verified partner teachers from Rishikesh and across India.
              </p>
              <p style={{ color: 'var(--accent)', fontSize: '0.95rem', fontWeight: '700', marginBottom: '24px' }}>
                We help you understand the course, teacher, batch timing, fee structure, installment options, dashboard access, exam process, and certificate details before you enroll.
              </p>
              <HighlightCard
                icon="rishikesh"
                type="gold"
                text="No confusion. No blind search. No unnecessary stress. Just the right guidance, the right teacher, and a clear learning journey."
                style={{ color: '#ffffff' }}
              />
            </div>

            <div className="cta-buttons" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
              <Link to="/courses" className="btn btn-white">Explore Yoga Courses</Link>
              <a 
                href="https://wa.me/919548354084?text=Hari%20Om%20PranaFlow%20Academy%2C%20I%20would%20like%20to%20know%20more%20about%20your%20yoga%20and%20wellness%20courses.%20Please%20guide%20me%20with%20the%20available%20programs%20and%20admission%20process."
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                style={{ backgroundColor: 'var(--secondary)', borderColor: 'var(--secondary)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}
              >
                Contact Our Admissions Team
              </a>
            </div>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
};

export default Home;
